import { IChatModsConfiguration, ICmChatResponseViewModel, ICsChatResponseViewModel, IGamesResponseViewModel, IGameResponseViewModel, ChatRoomConfiguration, IArcadeGameViewModel, IChatRoomGameViewModel } from '@/app-modules/config/models';
import { IHamsterRaceTicketSetConfigurationViewModel } from '@/app-modules/config/models/hamster-race-ticket-set-response-view-model';
import { ConnectionTimeoutOverride } from '../store/modules/user-preferences';

enum ConfigurationKey {
  NODE_ENV = 'NODE_ENV',
  CONFIG_ENV = 'CONFIG_ENV',
  API = 'API',
  TOMBOLA_TENANT = 'TOMBOLA_TENANT',
  CLIENT_TYPE_ID = 'CLIENT_TYPE_ID',
  CHAT_WEBSOCKET_SERVER_URL = 'CHAT_WEBSOCKET_SERVER_URL',
  CHAT_NEW_WEBSOCKET_SERVER_URL = 'CHAT_NEW_WEBSOCKET_SERVER_URL',
  CHAT_WEBSOCKET_KEEP_ALIVE_TIMEOUT_MILLISECONDS = 'CHAT_WEBSOCKET_KEEP_ALIVE_TIMEOUT_MILLISECONDS',
  CHAT_WEBSOCKET_CONNECTION_LOST_DETECTION_TIMEOUT_MILLISECONDS = 'CHAT_WEBSOCKET_CONNECTION_LOST_DETECTION_TIMEOUT_MILLISECONDS',
  ARCADE_CHAT_WEBSOCKET_SERVER_URL = 'ARCADE_CHAT_WEBSOCKET_SERVER_URL',
  GAME_WEBSOCKET_SERVER_URL = 'GAME_WEBSOCKET_SERVER_URL',
  GAME_NEW_WEBSOCKET_SERVER_URL = 'GAME_NEW_WEBSOCKET_SERVER_URL',
  IFRAME_GAME_URL = 'IFRAME_GAME_URL',
  GAME_WEBSOCKET_KEEP_ALIVE_TIMEOUT_MILLISECONDS = 'GAME_WEBSOCKET_KEEP_ALIVE_TIMEOUT_MILLISECONDS',
  GAME_WEBSOCKET_CONNECTION_LOST_DETECTION_TIMEOUT_MILLISECONDS = 'GAME_WEBSOCKET_CONNECTION_LOST_DETECTION_TIMEOUT_MILLISECONDS',
  BUILD_VERSION_NO = 'BUILD_VERSION_NO',
  MAX_CHAT_BUFFER_SIZE = 'MAX_CHAT_BUFFER_SIZE',
  MAX_WINNERS_LIST_SIZE = 'MAX_WINNERS_LIST_SIZE',
  DEFAULT_ALERT_WORDS = 'DEFAULT_ALERT_WORDS',
  FORGOTTEN_PASSWORD_URL = 'FORGOTTEN_PASSWORD_URL',
  ARCADE_HTP_CDN_URL = 'ARCADE_HTP_CDN_URL',
  ARCADE_HTP_CONFIG_URL = 'ARCADE_HTP_CONFIG_URL',
  GAME_WINNERS_DISPLAY_TIMEOUT_MS = 'GAME_WINNERS_DISPLAY_TIMEOUT_MS',
  GAME_HISTORY_REFRESH_INTERVAL_MS = 'GAME_HISTORY_REFRESH_INTERVAL_MS',
  DEPLOY_TENANT = 'DEPLOY_TENANT',
  INTERNATIONAL_UI_URL = 'INTERNATIONAL_UI_URL',
  ARCADE_MSG_ROOM_ID = 'ARCADE_MSG_ROOM_ID'
}

interface IApiConfiguration {
  url: string;
  netAPIUrl: string;
}

interface IConfigurationService {
  getConfigurationItem<T = string>(configurationKey: ConfigurationKey): T;
  getConfiguration(): Promise<IChatModsConfiguration>;
  getConfigurationSync(): IChatModsConfiguration;
  getGameConfiguration(): Promise<IGamesResponseViewModel>;
  getHamsterRaceTicketSetConfiguration(): Promise<IHamsterRaceTicketSetConfigurationViewModel>;
  getWebSocketOverrideBehaviour(): ConnectionTimeoutOverride | undefined;
  currentEnvironmentTenantIsInternational(): boolean;
}

interface IGameConfigurationService {
  getGameConfiguration(): Promise<IGameResponseViewModel[]>;
  getAllChatooms(): Promise<IChatRoomGameViewModel[]>;
  getArcadeGameConfiguration(): Promise<IArcadeGameViewModel[]>;
  getClubNameForGameNameAndClubId(gameName: string, clubId: number): Promise<string>;
  gameHasSingleActiveClub(gameName: string): Promise<boolean>;
  isGameAfreeGame(gameName: string): Promise<boolean>;
}

interface IChatConfigurationService {
  getChatConfiguration(): Promise<ChatRoomConfiguration[]>;
  getCmChatConfiguration(): Promise<ICmChatResponseViewModel>;
  getCsChatConfiguration(): Promise<ICsChatResponseViewModel>;
}

export { ConfigurationKey, IApiConfiguration, IConfigurationService, IGameConfigurationService, IChatConfigurationService };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/config/config-service-interface.ts